// This is for archived sites, which are hosted at https://vX.angular.io/, where X is the major Angular version.
export const environment = {
  legacyUniversalAnalyticsId: 'UA-8594346-15', // Production id (since it is linked from the main site)
  googleAnalyticsId: 'G-BVV0RDSG7F', // Production id (since it is linked from the main site)

  production: true,
  mode: 'archive',
};
